import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDnWuc8cvJzr8ITEkc9h_VlktDsBtxzY6k",
  authDomain: "pg-solucoes.firebaseapp.com",
  projectId: "pg-solucoes",
  storageBucket: "pg-solucoes.firebasestorage.app",
  messagingSenderId: "237724539816",
  appId: "1:237724539816:web:6cbb9c231b720596b25b9d"
};

// Inicializa Firebase
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth    = getAuth(app);

// Firestore com persistência offline — dados e escritas ficam no IndexedDB do dispositivo.
// Múltiplas abas são coordenadas via persistentMultipleTabManager.
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});

export const storage = getStorage(app);